<template>
    <div class="hotel-map" v-if="position">
        <GmapMap
            :center="position"
            :zoom="15"
            style="width: 100%; height: 100%"
        >
            <GmapMarker
                :position="position"
            />
            <gmap-info-window :options="infoOptions" :position="position" :opened="true">
                <h2 v-text="hotelName" class="hotel-map__title"></h2>
            </gmap-info-window>
        </GmapMap>
    </div>
</template>

<script>
export default {
    props: {
        hotel: {type: [Object, Array], default: null}
    },
    data() {
        return {
            infoOptions: {
                pixelOffset: {
                width: 0,
                height: -35
                }
          },
        }
    },
    computed: {
        hotelName() {
            if(this.hotel && this.hotel.name) {
                return this.hotel.name;
            }

            return '';
        },
        position() {
            if(this.hotel && this.hotel.latitude && this.hotel.longitude) {
                return {
                    lat: parseFloat(this.hotel.latitude),
                    lng: parseFloat(this.hotel.longitude)
                }
            }

            return null;
        }
    }
}
</script>
